<template>
    <div>
        <YesNoModal ref="YesNoModal" />
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <Loader ref="Loader"></Loader>
        <v-container fluid grid-list-xs>
            <v-layout justify-center wrap>
                <v-flex md12>
                    <v-card class="mb-5" elevation="4">
                        <v-layout row wrap ma-4>
                            <v-flex xs12 sm12 md12 lg12 xl12>
                                <v-btn
                                    v-if="HasAccess('CUSTOMER_MANAGEMENT', 'CREATE') || HasAccess('CUSTOMER_MANAGEMENT', 'MODIFY')"
                                    style="float:right;" color="success --darken-2"
                                    @click="ShowCustomerUserMaint(true, 0)">
                                    <v-icon>add</v-icon>Add Customer-User
                                </v-btn>
                                <v-data-table :headers="customerUserHeaders" :items="customerUserItems"
                                    :rows-per-page-items="[25,50,75,100]" :expand="expand" item-key="CustomerUser.ID">
                                    <template slot="no-data">There are no records</template>
                                    <template slot="no-results">No matching records found</template>
                                    <template slot="headerCell" slot-scope="{ header }">
                                        <span class="subheading font-weight-light text-success text--darken-3"
                                            v-text="header.text" />
                                    </template>
                                    <template v-slot:items="props">
                                        <tr @click="props.expanded = !props.expanded">
                                            <td>{{ props.item.CustomerUser.Name }}</td>
                                            <td>{{ props.item.CustomerUser.Username }}</td>
                                            <td style="float:right;">
                                                <v-menu dense bottom left>
                                                    <v-btn small slot="activator" color="primary" dark>
                                                        <v-icon>settings</v-icon>
                                                    </v-btn>
                                                    <div
                                                        v-if="HasAccess('CUSTOMER_MANAGEMENT', 'MODIFY') || HasAccess('CUSTOMER_MANAGEMENT', 'DELETE')">
                                                        <v-list dense v-for="(action, index) in customerUserActionItems"
                                                            :key="index">
                                                            <v-list-tile
                                                                @click="PerformCustUserOperation(action, props.item.CustomerUser)"
                                                                v-if="action.access == true">
                                                                <v-list-tile-action>
                                                                    <v-icon color="primary darken-2">{{ action.icon }}
                                                                    </v-icon>
                                                                </v-list-tile-action>
                                                                <v-list-tile-title>{{ action.title }}
                                                                </v-list-tile-title>
                                                            </v-list-tile>
                                                        </v-list>
                                                    </div>
                                                    <div v-else>
                                                        <v-list dense>
                                                            <v-list-tile>
                                                                <v-list-tile-title>
                                                                    You have no options
                                                                    available
                                                                </v-list-tile-title>
                                                            </v-list-tile>
                                                        </v-list>
                                                    </div>
                                                </v-menu>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-slot:expand="props">
                                        <v-layout row>
                                            <v-flex xs1 smd1 md1 v-for="venue in props.item.VenueList" :key="venue.ID">
                                                <v-card flat>
                                                    <v-card-text>
                                                        <v-chip color="secondary" text-color="white">{{ venue.Name }}
                                                        </v-chip>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>
                                        </v-layout>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="customerUserDialog" width="600px">
            <v-card>
                <v-toolbar color="secondary" dark dense>
                    <v-toolbar-title>Customer-User Maintenance</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn fab flat small>
                        <v-icon @click="customerUserDialog = false">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-form @submit.prevent="SubmitCustomerUserForm" ref="form" v-model="valid">
                    <v-card-text xs12 mt-3>
                        <v-layout>
                            <v-flex xs12>
                                <v-text-field label="Full name" v-model="customerUserForm.Name" :rules="fieldRules">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <!-- <v-layout>
                            <v-flex xs12>
                                <v-select label="Venue(s)" :items="VenueList" v-model="SelectedVenues" multiple
                                    item-text="Name" item-value="ID"></v-select>
                            </v-flex>
                        </v-layout> -->
                        <v-layout>
                            <v-flex xs12>
                                <v-text-field label="Email Address (username)" v-model="customerUserForm.Username"
                                    :rules="emailRules" autocomplete="new-password">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12>
                                <v-text-field label="Password"
                                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                                    @click:append="showPassword = !showPassword"
                                    :type="showPassword ? 'text' : 'password'" v-model="customerUserForm.Password"
                                    :rules="fieldRules" autocomplete="new-password"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-card-actions>
                            <v-layout justify-end>
                                <v-btn color="primary" @click="SubmitCustomerUserForm()">Save</v-btn>
                                <v-btn flat @click="customerUserDialog = false">Cancel</v-btn>
                            </v-layout>
                        </v-card-actions>
                    </v-card-text>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            let self = this;
            return {
                CustomerID: 0,
                e1: 0,
                customerUserDialog: false,
                expand: false,
                customerUser: null,
                CustomerUserID: null,
                showPassword: false,
                customerUserActionItems: [
                    // {
                    //     type: "modify",
                    //     title: "Modify",
                    //     access: self.HasAccess("CUSTOMER_MANAGEMENT", "MODIFY"),
                    //     icon: "edit"
                    // },
                    {
                        type: "delete",
                        title: "Delete",
                        access: self.HasAccess("CUSTOMER_MANAGEMENT", "DELETE"),
                        icon: "delete"
                    }
                ],
                customerUserHeaders: [{
                        sortable: true,
                        text: "Full name",
                        value: "CustomerUser.Name"
                    },
                    {
                        sortable: true,
                        text: "Email Address (username)",
                        value: "Username"
                    },
                    {
                        sortable: false,
                        align: "right",
                        text: "Actions"
                    }
                ],
                customerUserItems: [],
                customerUserForm: {
                    ID: 0,
                    CustomerID: 0,
                    Name: null,
                    Username: null,
                    Password: null
                },
                fieldRules: [v => !!v || "Field is required"],
                emailRules: [
                    v => !!v || "E-mail is required",
                    v => /.+@.+/.test(v) || "E-mail must be valid"
                ],
                place: null,
                valid: false,
                VenueList: [],
                SelectedVenues: null,
                roleList: [],
            }
        },
        props: ["prop_CustomerID"],
        watch: {
            prop_CustomerID(newID) {
                this.CustomerID = newID;
            },
        },
        mounted() {
            let self = this;

        },
        methods: {
            ShowCustomerUserMaint(add, id) {
                let self = this;
                self.GetVenuesByCustomer();
                console.log("CUST ID", self.CustomerID);
                self.customerUserDialog = true;
                self.customerUserAdd = add;
                self.custUserID = id;

                if (add == true) {
                    self.customerUserAdd = add;
                } else {
                    self.customerUserAdd = add;
                    self.custUserID = id;
                    self.fetchCustomerUserDataForModify();
                }

                console.log("ADD", self.customerUserAdd);
                console.log("Customer USER ID", self.custUserID);
            },
            fetchCustomerUserDataForModify() {
                let self = this;

                self.get(`CustomerUser?id=${self.custUserID}`).then(r => {
                    self.customerUserForm = r.data;

                    //self.SelectedVenues = self.GetVenueIDs(self.venueItemsCust);
                });
            },
            SubmitCustomerUserForm() {
                let self = this;

                self.customerUserForm.CustomerID = self.CustomerID;
                var newForm = {
                    CustomerUser: {
                        CustomerID: self.CustomerID,
                        Username: self.customerUserForm.Username,
                        Name: self.customerUserForm.Name,
                        Password: self.customerUserForm.Password
                    },
                    //VenueList: self.GetVenueItems()
                    VenueList: []
                };

                self.TestUsernameExists().then(result => {
                    if (result == true) {
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText("Username is taken");
                    } else {
                        if (self.customerUserAdd == true) {
                            self.post("CustomerUser", newForm)
                                .then(res => {
                                    console.log("CUSTOMER-USER POST", res.data);
                                    self.customerUserItems.push(res.data);
                                    self.customerUserDialog = false;
                                    self.customerUserForm = {
                                        ID: 0,
                                        Name: null,
                                        Username: null,
                                        Password: null
                                    };
                                })
                                .catch(err => {
                                    console.log(err);
                                    self.$refs.ErrorModal.show();
                                    self.$refs.ErrorModal.setText("Failed to create user");
                                });
                        } else {
                            self.put(`CustomerUser?id=${self.custUserID}`, newForm).then(r => {
                                console.log(r);
                                self.FetchCustomerUsers();
                                self.customerUserDialog = false;
                                self.customerUserForm = {
                                    ID: 0,
                                    Name: null,
                                    Username: null,
                                    Password: null
                                };
                            });
                        }
                    }

                })
            },
            GetVenueItems() {
                let self = this;
                let retVal = [];
                self.VenueList.forEach(element => {
                    let exists = self.SelectedVenues.filter(el => el == element.ID);
                    if (exists.length > 0) {
                        retVal.push(element);
                    }
                });
                return retVal;
            },
            GetVenuesByCustomer() {
                let self = this;

                self.get(`CustomerVenue/CustomerID?customerID=${self.CustomerID}`).then(r => {
                    self.VenueList = r.data;
                })
            },
            TestUsernameExists() {
                let self = this;
                return new Promise(resolve => {
                    self
                        .get(`CustomerUser/Exists?username=${self.customerUserForm.Username}`)
                        .then(result => {
                            resolve(result.data);
                        })
                        .catch(error => {
                            resolve(false);
                            self.$refs.ErrorModal.show();
                            self.$refs.ErrorModal.setText("Failed to check username");
                        });
                });
            },
            PerformCustUserOperation(action, item) {
                let self = this;
                switch (action.type.toUpperCase()) {
                    // case "MODIFY": {
                    //     self.modifyVenueItem(item);
                    // }
                    // break;
                    case "DELETE": {
                        self.deleteVenueItem(item);
                    }
                    break;
                }
            },
            modifyVenueItem(item) {
                let self = this;
                self.ShowCustomerUserMaint(false, item.ID);
            },
            deleteVenueItem(item) {
                let self = this;
                console.log("cust user items", self.customerUserItems)
                console.log("cut user item", item)
                self.$refs.YesNoModal.show(
                    "Are you sure you want to delete this customer-user?",
                    function (yes) {
                        if (yes == true) {
                            self
                                .delete(`CustomerUser?id=${item.ID}`)
                                .then(result => {
                                    if (result.data == true) {
                                        var index = self.customerUserItems.indexOf(item);
                                        if (index > -1) {
                                            self.customerUserItems.splice(index, 1);
                                        }
                                    }
                                })
                                .catch(error => {
                                    self.$refs.ErrorModal.show();
                                    self.$refs.ErrorModal.setText(error.toString());
                                });
                        }
                    }
                );
            },
        }
    }
</script>

<style>

</style>